export const LLM_PROVIDER = {
    AZURE_OPENAI: 'Azure OpenAI',
    GOOGLE_GEMINI: 'Google Gemini',
    SNOWFLAKE_MISTRAL: 'Snowflake Mistral',
};
export const PROVIDER_CONFIG = {
    'Azure OpenAI': {
        id: LLM_PROVIDER.AZURE_OPENAI,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/azure-logo.svg',
        isEarlyAccess: false,
        requiredFields: ['apiKey', 'endpoint', 'model'],
    },
    'Google Gemini': {
        id: LLM_PROVIDER.GOOGLE_GEMINI,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/google-logo.svg',
        isEarlyAccess: true,
        requiredFields: ['apiKey', 'model', 'region'],
    },
    'Snowflake Mistral': {
        id: LLM_PROVIDER.SNOWFLAKE_MISTRAL,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/snowflake-logo.svg',
        isEarlyAccess: true,
        requiredFields: [
            'apiKey',
            'endpoint',
            'model',
            'passphrase',
            'user',
            'account',
        ],
    },
};
export const LLM_CONFIG_ID = 'orion.aiModelType';
export const emptyFormState = {
    apiKey: '',
    apiVersion: '',
    endpoint: '',
    model: '',
    provider: '',
    region: '',
    passphrase: '',
    user: '',
    account: '',
};
export const LLM_FORM_ERRORS = {
    apiKey: 'Api key is required',
    endpoint: 'Endpoint is required',
    region: 'Region is required',
    account: 'Account name is required',
    passphrase: 'Passphrase is required',
    user: 'Username is required',
};
//# sourceMappingURL=llm-form-constants.js.map